<template>
  <v-row justify="center">
    <v-dialog v-model="modal" persistent :max-width="maxWidth">
      <v-form
        ref="form"
        v-model="isFormValid"
        lazy-validation
        @submit.prevent="submitModal"
      >
        <div class="d-modal">
          <div class="d-modal__header">
            <h3 class="text-h7">{{ title }}</h3>
          </div>
          <div class="d-modal__body">
            <slot name="body"></slot>
          </div>
          <div class="d-modal__footer">
            <div class="d-flex align-center justify-end">
              <v-btn
                v-if="!hideCancelButton"
                class="text-none body-2 font-weight-medium mr-3"
                depressed
                @click="closeModal"
                text
              >
                {{ cancelButtonText }}
              </v-btn>
              <v-btn
                v-if="!hideSubmitButton"
                type="submit"
                class="text-none body-2 font-weight-medium"
                depressed
                :loading="isSubmitting"
                :disabled="isSubmitting"
                :color="submitButtonColor"
              >
                {{ submitButtonText }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    modal: Boolean,
    submitButtonText: {
      type: String,
      default: function () {
        return this.$t("defaults.button.save");
      },
    },
    cancelButtonText: {
      type: String,
      default: function () {
        return this.$t("defaults.button.close-modal");
      },
    },
    title: String,
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    submitButtonColor: {
      type: String,
      default: "success",
    },
    hideCancelButton: {
      type: Boolean,
      default: false,
    },
    hideSubmitButton: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: "570px",
    },
  },
  data() {
    return {
      isFormValid: true,
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    submitModal() {
      if (this.$refs.form.validate() && this.isFormValid) {
        this.$emit("submitModal");
      }
    },
  },
};
</script>
